import React, { useState, useEffect } from 'react'
import styles from './Login.module.css'
import { useDispatch } from 'react-redux'
import { useHistory, Link } from 'react-router-dom'
import { signin } from '../../actions/auth'
import { useSnackbar } from 'react-simple-snackbar'

const initialState = {
  email: '',
  password: '',
}
const FEATURES = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
      </svg>
    ),
    text: 'Importez le fichier Excel RH et générez les factures automatiquement',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    ),
    text: 'Envoyez les factures aux coaches par email en masse ou personnalisé',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
    text: 'Suivez les campagnes mensuelles et téléchargez les PDF',
  },
]

const Login = () => {
  const [formData, setFormData] = useState(initialState)
  const [rememberMe, setRememberMe] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const [openSnackbar] = useSnackbar()
  const user = JSON.parse(localStorage.getItem('profile'))
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const savedEmail = localStorage.getItem('rememberedEmail')
    if (savedEmail) {
      setFormData((prev) => ({ ...prev, email: savedEmail }))
      setRememberMe(true)
    }
  }, [])

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (loading) return
    setLoading(true)

    if (rememberMe) {
      localStorage.setItem('rememberedEmail', formData.email)
    } else {
      localStorage.removeItem('rememberedEmail')
    }

    dispatch(signin(formData, openSnackbar, setLoading))
  }

  if (user) {
    const role = user?.result?.role
    history.push(role === 'corporate' ? '/corporate/dashboard' : '/dashboard')
    return null
  }

  return (
    <div className={styles.layout}>
      <div className={styles.leftPanel}>
        <div className={styles.leftOverlay}>
          <div className={styles.leftContent}>
            <h1 className={styles.leftTitle}>California Gym</h1>
            <p className={styles.leftSubtitle}>Facturation des coaches</p>

            <div className={styles.features}>
              {FEATURES.map((feature, i) => (
                <div key={i} className={styles.featureCard}>
                  <div className={styles.featureIcon}>{feature.icon}</div>
                  <p>{feature.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.rightPanel}>
        <div className={styles.rightInner}>
          <div className={styles.topBrand}>
            <img
              src="/cg-logo.png"
              alt="California Gym"
              className={styles.logo}
            />
            <p className={styles.tagline}>Gestion de la facturation interne</p>
          </div>

          <div className={styles.formCard}>
            <h2 className={styles.formTitle}>Bienvenue</h2>
            <p className={styles.formSubtitle}>
              Connectez-vous à votre compte RH California Gym
            </p>

            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.fieldGroup}>                <label htmlFor="email">Adresse email</label>
                <div className={styles.inputWrap}>
                  <span className={styles.inputIcon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </span>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="votre@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    autoFocus
                  />                </div>
              </div>

              <div className={styles.fieldGroup}>
                <label htmlFor="password">Mot de passe</label>
                <div className={styles.inputWrap}>
                  <span className={styles.inputIcon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                  </span>
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Votre mot de passe"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                  <button
                    type="button"
                    className={styles.eyeBtn}
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label="Afficher le mot de passe"
                  >
                    {showPassword ? (
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                        <line x1="1" y1="1" x2="23" y2="23" />
                      </svg>
                    ) : (
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <div className={styles.formOptions}>                  <label className={styles.checkbox}>
                    <input
                      type="checkbox"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    Se souvenir de moi
                  </label>
                  <Link to="/forgot" className={styles.forgotLink}>
                    Mot de passe oublié ?
                  </Link>
              </div>

              <button type="submit" className={styles.submitBtn} disabled={loading}>                {loading ? (
                  <span className={styles.spinner} />
                ) : (
                  <>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                    Se connecter
                  </>
                )}
              </button>

              <p className={styles.adminNote}>
                Accès sur invitation uniquement. Contactez votre administrateur pour obtenir un compte.
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
